module.exports = __webpack_public_path__ + "img/profile_img6.05a60514.gif";